import { render } from "./tpl_flex_one.vue?vue&type=template&id=2b9b55f1&scoped=true"
import script from "./tpl_flex_one.vue?vue&type=script&lang=js"
export * from "./tpl_flex_one.vue?vue&type=script&lang=js"

import "./tpl_flex_one.vue?vue&type=style&index=0&id=2b9b55f1&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9b55f1"],['__file',"src/views/wap/template/tpl_flex_one.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b9b55f1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b9b55f1', __exports__)) {
    console.log('reload')
    api.reload('2b9b55f1', __exports__)
  }
  
  module.hot.accept("./tpl_flex_one.vue?vue&type=template&id=2b9b55f1&scoped=true", () => {
    console.log('re-render')
    api.rerender('2b9b55f1', render)
  })

}


export default __exports__